"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const text_1 = __importStar(require("../../../components/text/text"));
const utils_1 = require("../../../utils/utils");
const input_1 = __importStar(require("../../../components/input/input"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const colors_1 = __importDefault(require("../../../styles/colors"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const labelButton_1 = __importDefault(require("../../../components/labelButton/labelButton"));
const MBSApprovedConnection = ({ mbsStatusMessage, ticketId, setTicketId, password, setPassword, errors, confirmMBS, connectSmsNotReceived, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(text_1.default, { style: [
                styles_1.default.minimumMarginBetweenElementsVertically,
                { fontWeight: 'bold', textAlign: 'center' },
            ], color: colors_1.default.COLOR_PRIMARY, titleType: text_1.TEXT_TYPE_SUBTITLE }, mbsStatusMessage),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TICKET_ID, label: "Ticket ID (xxxxxxx-xx)", placeholder: "Ticket ID (xxxxxxx-xx)", setValue: setTicketId, error: (0, utils_1.getError)('ticket_no', errors), value: ticketId }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PASSWORD, placeholder: "Password", label: "Password", setValue: setPassword, error: (0, utils_1.getError)('statement_password', errors), value: password }),
        react_1.default.createElement(primaryButton_1.default, { title: "APPROVE CONNECTION", onPress: confirmMBS, eventName: "confirm_my_bank_statement", disabled: false }),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.minimumMarginBetweenElementsVertically },
            react_1.default.createElement(labelButton_1.default, { eventName: "tap_didnt_receive_sms_label", onPress: connectSmsNotReceived, title: "I have not received a SMS. What can I do?" }))));
};
exports.default = MBSApprovedConnection;
